export const Logo = ({ size = "md" }) => (
  <a
    href="#explore"
    aria-label="VIEWNA home"
    data-testid="viewna-logo"
    className="inline-flex items-center transition-transform duration-300 hover:scale-[1.03]"
  >
    <img
      src="/assets/viewna_logo.png"
      alt="VIEWNA"
      className={`${
        size === "lg" ? "h-24 sm:h-32" : "h-12 sm:h-14"
      } w-auto object-contain drop-shadow-[0_0_18px_rgba(212,175,55,0.25)]`}
    />
  </a>
);

export default Logo;
